<template>
    <rkm-modal
        :loading="loading"
        :title="`Processos (${paciente.nome})`"
        extraLarge
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="processos"
            :tbody-tr-class="rowClass"
            class="table-processos"
            sort-by="solicitadoEm"
            sort-desc
        >
            <template v-slot:cell(itens)="{ item }">
                <div
                    v-for="material in item.materiais"
                    :key="material"
                >
                    {{ material }}
                </div>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :title="item.createdCentroCustoId == centroCusto.id ? 'Editar' : 'Visualizar'"
                    @click="$router.push({ name: 'farmacia-alto-custo-gerenciamento-processo-edit', params: {
                        pacienteId: paciente.id,
                        id: item.id
                    }})"
                    authorize="edit-farmacia-alto-custo-gerenciamento-processo"
                    color="primary"
                    small
                >
                    <rkm-icon :icon="item.createdCentroCustoId == centroCusto.id ? 'pen' : 'eye'" />
                </rkm-button>

                <rkm-button
                    :disabled="item.createdCentroCustoId != centroCusto.id"
                    @click="excluir(item.id)"
                    authorize="destroy-farmacia-alto-custo-gerenciamento-processo"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>

            <template #afterPagination>
                <div class="mt-2">
                    <rkm-row>
                        <rkm-col>
                            <p class="m-0">A linha em <span class="yellow">amarela</span> representa que o processo não pertence ao centro de custo logado.</p>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$router.push({ name: 'farmacia-alto-custo-gerenciamento-processo-create', params: { pacienteId: paciente.id }})"
                authorize="create-farmacia-alto-custo-gerenciamento-processo"
                color="primary"
            >
                Cadastrar processo
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { repository, error, formats } from '@/mixins'

export default {
    created() {

        this.repositories = {
            altoCustoGerenciamentoProcesso: this.getConectaSusRepository('farmacia.altoCustoGerenciamentoProcesso'),
        }
    },
    computed: {
        ...mapGetters({ loading: 'getLoading', centroCusto: 'getCentroCusto' }),
        fields() {

            return [
                {
                    key: 'solicitadoEm',
                    label: 'Data da solicitação',
                    class: 'col-min text-center',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                    sortable: true
                },
                { key: 'tipo', label: 'Tipo', sortable: true },
                { key: 'itens', label: 'Medicamentos' },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' }
            ]
        }
    },
    data: () => ({
        paciente: {},
        processos: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(paciente) {

            this.paciente = paciente
            this.processos = []

            this.$refs.Modal.show()
            this.load()
        },
        load() {

            this.setLoading();

            this.repositories.altoCustoGerenciamentoProcesso.index(this.paciente.id)
                .then(({ data }) => this.processos = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        excluir(id) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o processo?',
                async () => {

                    this.setLoading();

                    this.repositories.altoCustoGerenciamentoProcesso.destroy(id)
                        .then(() => this.processos.splice(this.processos.findIndex(p => p.id === id), 1))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                },
                this.handleError
            )
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.createdCentroCustoId != this.centroCusto.id) {

                return 'table-warning'
            }
        }
    },
    mixins: [repository, error, formats]
}
</script>

<style scoped>
.table-processos >>> .yellow { color: #e6c619; }
</style>